const menus = [
    {
        id: 1,
        name: 'Trang chủ',
        links: '/',
    },
    {
        id: 2,
        name: 'Vật phẩm',
        links: '/marketplace',
    },
    {
        id: 3,
        name: 'Giao dịch',
        links: '/transaction-history',
    },
    {
        id: 4,
        name: 'Bán cho chúng tôi',
        links: '/sell',
    },
    {
        id: 5,
        name: 'Đặt hàng',
        links: '/order',
    },
    {
        id: 6,
        name: 'Hợp tác',
        links: '/collab',
    },
    {
        id: 7,
        name: 'Liên hệ',
        links: '/contact',
    },
    // {
    //     id: 5,
    //     name: 'Page',
    //     links: '#',
    //     namesub: [
    //         {
    //             id: 1,
    //             sub: 'Authors 01',
    //             links: '/authors-01'
    //         },
    //         {
    //             id: 2,
    //             sub: 'Authors 02',
    //             links: '/authors-02'
    //         },
    //         {
    //             id: 3,
    //             sub: 'Wallet Connect',
    //             links: '/wallet-connect'
    //         },
    //         {
    //             id: 4,
    //             sub: 'Create Item',
    //             links: '/create-item'
    //         },
    //         {
    //             id: 5,
    //             sub: 'Edit Profile',
    //             links: '/edit-profile'
    //         },
    //         {
    //             id: 6,
    //             sub: 'Ranking',
    //             links: '/ranking'
    //         },
    //         {
    //             id: 7,
    //             sub: 'Login',
    //             links: '/login'
    //         },
    //         {
    //             id: 8,
    //             sub: 'Sign Up',
    //             links: '/sign-up'
    //         },
    //         {
    //             id: 9,
    //             sub: 'No Result',
    //             links: '/no-result'
    //         },
    //         {
    //             id: 10,
    //             sub: 'FAQ',
    //             links: '/faq'
    //         }
    //     ],
    // },
    // {
    //     id: 7,
    //     name: 'Contact',
    //     links: '/contact-01',
    //     namesub: [
    //         {
    //             id: 1,
    //             sub: 'Contact 1',
    //             links: '/contact-01'
    //         },
    //         {
    //             id: 2,
    //             sub: 'Contact 2',
    //             links: '/contact-02'
    //         }
    //     ],
    // },
]

export default menus
